import {PayloadAction, createSlice} from "@reduxjs/toolkit";
import { UserInfoShort } from "app/websocket";

interface ChatProps {
    listBlockedUsers?: UserInfoShort[];
}

const initialState: ChatProps = {
    listBlockedUsers: undefined,
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const chat = createSlice({
    name: "chat",
    initialState,
    reducers: {
        setBlockedUsers(state, action: PayloadAction<UserInfoShort[]>) {
            state.listBlockedUsers = action.payload;
        },
    },
});

export default chat.reducer;

export const {setBlockedUsers} = chat.actions;
